import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useAmbienteMedicao } from "../../../contexts/AmbienteMedicaoContext";
import useApi from "../../../hooks/useApi";

const ModalEditarGrupo = ({ grupo, fecharModal, onUpdated }) => {

    const { ambiente } = useAmbienteMedicao();
    const api = useApi();

    const [saving, setSaving] = useState(false);
    const [formValues, setFormValues] = useState({
        descricao: grupo?.descricao || ""
    });

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value.toUpperCase()
        }));

    }

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!grupo?.id) return;

        if (!formValues.descricao.trim()) {
            alert("Informe a descrição do grupo.");
            return;
        }

        try {

            setSaving(true);

            const formData = new FormData();
            formData.append("id", grupo.id);
            formData.append("descricao", formValues.descricao);

            await api.post("/Painel/API/ControleMedicao/UpdateGrupo/", formData);

            if (onUpdated) onUpdated();
            fecharModal();

        } catch (e) {

            console.error(e);

        } finally {

            setSaving(false);

        }

    }

    return (
        <Overlay state={true}>
            <Modal header close={fecharModal}>
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="OBRA"
                        type="text"
                        readOnly
                        valor={ambiente?.descricao || ""}
                    />
                    <FormComp
                        title="NÚMERO DO GRUPO"
                        type="text"
                        readOnly
                        valor={String(grupo?.number ?? "")}
                    />
                    <FormComp
                        title="DESCRIÇÃO DO GRUPO"
                        type="text"
                        name="descricao"
                        valor={formValues.descricao}
                        changeFunc={handleChange}
                        required
                    />
                    <FormComp
                        type="submit"
                        valor={saving ? "SALVANDO..." : "SALVAR"}
                        disabled={saving}
                    />
                </Formulario>
            </Modal>
        </Overlay>
    )

}

export default ModalEditarGrupo;
